import { getConversionReportingEnablementSettingRpc } from 'automation-ui-canvas/__generated__/chirp/com/hubspot/automation/reporting/rpc/ConversionRpc';
import { registerQuery, useQuery } from 'data-fetching-client';
import authHttpClient from 'hub-http/clients/apiClient';
import { createRpcClientV2 } from 'rpc-client-utils';
import { jsx as _jsx } from "react/jsx-runtime";
const chirpClient = createRpcClientV2({
  hubHttpClient: authHttpClient
});
export const FETCH_ENROLLMENT_CONVERSION_STATUS = registerQuery({
  fieldName: 'fetchEnrollmentConversionStatus',
  args: ['flowId'],
  fetcher({
    flowId
  }) {
    return chirpClient.call(getConversionReportingEnablementSettingRpc, {
      request: {
        flowId: flowId !== null && flowId !== void 0 ? flowId : 0
      }
    });
  }
});
export const wireGetEnrollmentConversionTrackingStatus = WrappedComponent => props => {
  var _data$fetchEnrollment;
  const {
    flowId: stringId
  } = props.match.params;
  const flowId = Number(stringId);
  const {
    data,
    loading,
    refetch: refetchReportingEnabledStatus
  } = useQuery(FETCH_ENROLLMENT_CONVERSION_STATUS, {
    variables: {
      flowId
    },
    fetchPolicy: 'network-only'
  });
  const isReportingEnabled = (_data$fetchEnrollment = data === null || data === void 0 ? void 0 : data.fetchEnrollmentConversionStatus.conversionReportingEnabled) !== null && _data$fetchEnrollment !== void 0 ? _data$fetchEnrollment : false;
  return /*#__PURE__*/_jsx(WrappedComponent, Object.assign({}, props, {
    isReportingEnabled: isReportingEnabled,
    reportingStatusLastUpdated: data === null || data === void 0 ? void 0 : data.fetchEnrollmentConversionStatus.lastUpdateTimestamp,
    reportingStatusLoading: loading,
    refetchReportingEnabledStatus: refetchReportingEnabledStatus
  }));
};